var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"small":"","text":"","color":"secondary","disabled":_vm.disabled},on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.selected ? 'Unselect All' : 'Select All')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }